import type {ReactElement} from 'react';
import {useState} from 'react';
import {Text, TextSize} from '@Components/text';
import {useElapsedSeconds} from '@Components/ai-chat-window/hooks/useElapsedSeconds';
import {getStepHeaderText} from '@Components/document-chip/document-chip.library';
import type {DocumentChipStepTextProps} from './document-chip-step-text.types';

/** The parent keys this by step, so a new step remounts it and its clock starts from zero in the same render. */
export function DocumentChipStepText({stepLabel}: DocumentChipStepTextProps): ReactElement {
  const [stepStartedAt] = useState((): number => Date.now());
  const elapsedSeconds = useElapsedSeconds(stepStartedAt);

  return <Text val={getStepHeaderText(stepLabel, elapsedSeconds)} size={TextSize.SM} bold />;
}
